import { createApp } from 'vue'
//import App from './App.vue'
//import './registerServiceWorker'
//import router from './router'
//import store from './store'
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';

import VCalendar from 'v-calendar';
import 'v-calendar/style.css';

import FormContainer from './components/FormContainer.vue';
const app = createApp({
    el:'#app'
});
app.use(VCalendar, {})
// Register the global component
app.component('form-container', FormContainer);
app.mount('#app');
//app.use(store).use(router).mount('#app');

//app.use(store).use(router).mount('#app')
